import { StaffDialogs } from '@/components/staff/StaffDialogs';
import { StaffRouteView } from '@/components/staff/StaffRouteView';
import { useStaffViewModel } from '@/hooks/useStaffViewModel';


export default function StaffView() {
  const { routeData, routeActions, dialogData, dialogActions, staffHelpers } = useStaffViewModel();

  return (
    <div className="min-h-screen w-full animate-fade-in bg-[#eef7ff] px-0 pb-28 pt-0 sm:bg-[#f8fafc]" data-testid="staff-view-page">
      <StaffRouteView
        data={routeData}
        actions={routeActions}
        helpers={staffHelpers}
      />

      <StaffDialogs
        data={dialogData}
        actions={dialogActions}
        helpers={staffHelpers}
      />
    </div>
  );
}
